module.exports = __webpack_public_path__ + "static/media/logout.752e8999.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/logout.svg
// module id = 568
// module chunks = 1